const SYMBOLS_MAP: Record<string, string> = {
  '0': '₀',
  '1': '₁',
  '2': '₂',
  '3': '₃',
  '4': '₄',
  '5': '₅',
  '6': '₆',
  '7': '₇',
  '8': '₈',
  '9': '₉',
}

const numberToSubscriptString = (value: number): string => value
  .toString()
  .split('')
  .map((char) => SYMBOLS_MAP[char] ?? char)
  .join('');

export default numberToSubscriptString;
